// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodSensoryQuestionType } from './FoodSensoryQuestionType';
import { operatorId } from './Operator';
import { brewSensoryFormId } from './BrewSensoryForm';
import { z } from 'zod';
export const brewSensoryQuestionId = (z.number());
export const brewSensoryQuestion = z.object({
    id: brewSensoryQuestionId,
    text: z.string(),
    question_type: foodSensoryQuestionType,
    options: z.unknown().nullable(),
    min_value: z.number(),
    max_value: z.number(),
    min_label: z.string().nullable(),
    max_label: z.string().nullable(),
    display_order: z.number(),
    required: z.boolean(),
    deleted_at: z.date().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    is_acceptance: z.boolean(),
    form_id: brewSensoryFormId,
});
export const brewSensoryQuestionInitializer = z.object({
    id: brewSensoryQuestionId.optional(),
    text: z.string(),
    question_type: foodSensoryQuestionType,
    options: z.unknown().optional().nullable(),
    min_value: z.number().optional(),
    max_value: z.number().optional(),
    min_label: z.string().optional().nullable(),
    max_label: z.string().optional().nullable(),
    display_order: z.number().optional(),
    required: z.boolean().optional(),
    deleted_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    is_acceptance: z.boolean().optional(),
    form_id: brewSensoryFormId,
});
export const brewSensoryQuestionMutator = z.object({
    id: brewSensoryQuestionId.optional(),
    text: z.string().optional(),
    question_type: foodSensoryQuestionType.optional(),
    options: z.unknown().optional().nullable(),
    min_value: z.number().optional(),
    max_value: z.number().optional(),
    min_label: z.string().optional().nullable(),
    max_label: z.string().optional().nullable(),
    display_order: z.number().optional(),
    required: z.boolean().optional(),
    deleted_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    is_acceptance: z.boolean().optional(),
    form_id: brewSensoryFormId.optional(),
});
//# sourceMappingURL=BrewSensoryQuestion.js.map